export default "__VITE_ASSET__BkUWNDF9__"